import analytics from '@finn-no/analytics';
import { Params } from '../helpers/url-parse';
import { EventTrackingConfig } from '@finn-no/analytics/lib/types';

export function trackEvent(params: Params) {
    _trackEvent(getEventObject(params));
}

export function getEventObject(params: Params): EventTrackingConfig {
    let stringValue = `channel:${params.channel}, distribution:${params.distribution}`;
    if (params.cid) {
        stringValue = `${stringValue}, variant:${params.cid}`;
    }
    return {
        analyticsName: 'promotions.distribution-blink.click',
        stringValue,
        numberValue:
            typeof params.score === 'string'
                ? parseInt(params.score, 10)
                : params.score || undefined,
        context: {
            referrer: `http://www.finn-blink.no/synthesised-referrer/${params.channel}`,
        },
    };
}

function _trackEvent(e: EventTrackingConfig) {
    analytics.trackEvent(e);
}

export function trackPage() {
    analytics.trackPage({ context: { reportSuiteOverride: 'finnblink' } });
}
